import { BaseBrush, Canvas, Circle, Path, Point } from 'fabric';

export class PathEraserBrush extends BaseBrush {
  constructor(canvas: Canvas) {
    super(canvas);
    this.width = 10;
  }

  _render() {}

  onMouseUp() {}

  onMouseDown(pointer: Point) {
    this.erase(pointer);
  }

  onMouseMove(pointer: Point) {
    this.erase(pointer);
  }

  erase(pointer: Point) {
    const zoom = this.canvas.getZoom();
    const brushRadius = this.width / 2 / zoom; // adjust for zoom level
    const brushCircle = new Circle({
      left: pointer.x,
      top: pointer.y,
      radius: brushRadius,
      originX: 'center',
      originY: 'center',
      absolutePositioned: true, // ensures accurate positioning with transformations
    });
    const objects = this.canvas.getObjects();
    const pathsToRemove: Path[] = [];

    objects.forEach(obj => {
      if (obj instanceof Path) {
        const isIntersecting = obj.intersectsWithObject(brushCircle);
        if (isIntersecting) {
          pathsToRemove.push(obj);
        }
      }
    });

    pathsToRemove.forEach(path => {
      this.canvas.remove(path);
    });

    this.canvas.requestRenderAll();
  }
}
